import { CACHE_DURATION } from "../../constants";

const CACHE_KEY = "learningCatalogue_rawCatalogue";

/**
 * Cache for raw catalogue data.
 * Uses sessionStorage so it survives full page reload (F5) and navigation.
 * Valid for CACHE_DURATION; cleared when tab/window is closed.
 */
function getStorage() {
  try {
    return typeof sessionStorage !== "undefined" ? sessionStorage : null;
  } catch {
    return null;
  }
}

function readFromStorage() {
  const storage = getStorage();
  if (!storage) {
    return { data: null, timestamp: null };
  }
  try {
    const raw = storage.getItem(CACHE_KEY);
    if (!raw) {
      return { data: null, timestamp: null };
    }
    const parsed = JSON.parse(raw);
    return {
      data: parsed.data ?? null,
      timestamp: typeof parsed.timestamp === "number" ? parsed.timestamp : null,
    };
  } catch {
    return { data: null, timestamp: null };
  }
}

function writeToStorage(data, timestamp) {
  const storage = getStorage();
  if (!storage) {
    return;
  }
  try {
    if (data == null || timestamp == null) {
      storage.removeItem(CACHE_KEY);
      return;
    }
    storage.setItem(CACHE_KEY, JSON.stringify({ data, timestamp }));
  } catch {
    // ignore quota or disabled storage
  }
}

export const cacheService = {
  isValid() {
    const { data, timestamp } = readFromStorage();
    if (!data || timestamp == null) {
      return false;
    }
    return Date.now() - timestamp < CACHE_DURATION;
  },

  getValidData() {
    const { data, timestamp } = readFromStorage();
    if (!data || timestamp == null) {
      return null;
    }
    if (Date.now() - timestamp >= CACHE_DURATION) {
      return null;
    }
    return data;
  },

  set(data) {
    if (data == null) {
      writeToStorage(null, null);
      return;
    }
    const timestamp = Date.now();
    writeToStorage(data, timestamp);
  },

  clear() {
    writeToStorage(null, null);
  },
};
